/* eslint-disable no-unused-vars */
import { t } from 'i18next';
import { translatedText } from '../../i18n/config';

export function tradErrorToaster() {
    const tradErrorToasterError = translatedText('messages.error', t);
    return { tradErrorToasterError };
}
